import Button from 'components/Button';
import { AlertType } from 'components/alert/Alert';
import Form from 'components/formElements/Form';
import FormField from 'components/formElements/FormField';
import FormInput from 'components/formElements/FormInput';
import FormLabel from 'components/formElements/FormLabel';
import UseAlert from 'hooks/UseAlert';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { forgotPassword } from 'services/User';

interface FormModel {
  email: string;
}

/**
 * Request a password reset component
 */
function ForgotPasswordRequest(): JSX.Element {
  const [submitting, setSubmitting] = useState<boolean>(false);

  const navigate = useNavigate();
  const { alertElement: errorAlertElement, setMessage: setErrorMessage } = UseAlert(AlertType.Danger);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormModel>();

  /**
   * Function that be called when submitting the form
   */
  const onSubmit = async ({ email }: FormModel) => {
    try {
      setSubmitting(true);
      await forgotPassword(email);

      setErrorMessage('');
      navigate('/#forgot-password-requested');
    } catch (error) {
      setErrorMessage(error as string);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {errorAlertElement}

      <Form onSubmit={handleSubmit(onSubmit)}>
        <FormField>
          <FormLabel htmlFor='name'>Email</FormLabel>
          <FormInput
            type='email'
            error={errors.email}
            placeholder='johndoe@example.com'
            {...register('email', { required: 'this field is required' })}
          />
        </FormField>

        <div className='flex justify-center my-3'>
          <Button htmlType='submit' type='primary' loading={submitting} fullWidth={true}>
            Request new password
          </Button>
        </div>

        <div className='flex justify-center items-center text-gray-700 dark:text-gray-200'>
          <Link to='/' className='text-sm mr-2'>
            Return to login
          </Link>
        </div>
      </Form>
    </>
  );
}

export default ForgotPasswordRequest;
